import React from "react";
import { Grid, TextField, MenuItem, InputAdornment } from "@mui/material";
import { Current } from "../../models/signalUsers/current.ts";
import { Signal } from "../../models/signal.ts";
import { getSignalLabelFromList } from "../../utils/signalUtils.ts";
import { useResistorOptions } from "../../hooks/useResistorOptions.ts"

interface Props {
  data: Current;
  setIsValid: (isValid: boolean) => void;
  onChange: (voltage: Current) => void;
  signalOptions: Signal[];
}
const EditVoltageForm: React.FC<Props> = ({ data, setIsValid, onChange, signalOptions }) => {
    const { options } = useResistorOptions();
    const maxCurrent = 3;
    const handleChange = (current: Current) => {
        current.shunt = calculateShunt(current.max);
        current.power = current.max * current.max * current.shunt;

        onChange(current);
        if (current.high_signal.id === current.low_signal.id || current.high_signal.id === "" || current.low_signal.id === "" || current.max <= 0 || current.max > maxCurrent) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }
    };

    
    const calculateShunt = (maxCurrent: number): number => {
        const shuntInTheory = 0.03 / maxCurrent;
        const resistors = options.sort((a, b) => b - a);
        const shunt = resistors.find(r => r <= shuntInTheory);
        return shunt ?? resistors[resistors.length - 1];
    };

    return (
        <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid size={{ xs: 12, sm: 12 }}>
                <TextField
                select fullWidth label="Signal +"
                value={data.high_signal.id}
                error={data.high_signal.id === "" || data.high_signal.id === data.low_signal.id}
                onChange={(e) => {
                    const selected = signalOptions.find(s => s.id === e.target.value);
                    if (selected) handleChange({ ...data, high_signal: selected });
                }}
                >
                {signalOptions.map(opt => (
                    <MenuItem key={opt.id} value={opt.id}>{getSignalLabelFromList(opt.id, signalOptions)}</MenuItem>
                ))}
                </TextField>
            </Grid>
            <Grid size={{ xs: 12, sm: 12 }}>
                <TextField
                select fullWidth label="Signal -"
                value={data.low_signal.id}
                error={data.low_signal.id === "" || data.high_signal.id === data.low_signal.id}
                onChange={(e) => {
                    const selected = signalOptions.find(s => s.id === e.target.value);
                    if (selected) handleChange({ ...data, low_signal: selected });
                }}
                >
                {signalOptions.map(opt => (
                    <MenuItem key={opt.id} value={opt.id}>{getSignalLabelFromList(opt.id, signalOptions)}</MenuItem>
                ))}
                </TextField>
            </Grid>
            <Grid size={{ xs: 12, sm: 12 }}>
                <TextField
                label="Max. Strom"
                type="number"
                fullWidth
                inputProps={{ step: 0.01, min: 0 }}
                error={data.max <= 0 || data.max > maxCurrent}
                value={data.max}
                onChange={(e) => handleChange({ ...data, max: parseFloat(e.target.value) })}
                InputProps={{
                    endAdornment: <InputAdornment position="end">A</InputAdornment>,
                }}
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                    label="Shunt-Widerstand"
                    value={(data.shunt*1000).toFixed(1)}
                    fullWidth
                    variant="filled"
                    disabled
                    InputProps={{ 
                        readOnly: true,
                        endAdornment: <InputAdornment position="end">mΩ</InputAdornment>,
                    }}
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                    label="Verlustleistung"
                    value={(data.power*1000).toFixed(0)}
                    fullWidth
                    variant="filled"
                    disabled
                    InputProps={{ 
                        readOnly: true,
                        endAdornment: <InputAdornment position="end">mW</InputAdornment>,
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default EditVoltageForm;
